import numeral from 'numeral';

// ----------------------------------------------------------------------

type InputValue = string | number | null;

export function fNumber(number: InputValue, format = '0,0.00') {
  return numeral(number).format(format);
}

export function fInteger(number: InputValue) {
  return numeral(number).format('0,0');
}

export function fCurrency(number: InputValue) {
  const format = number ? numeral(number).format('$0,0.000') : '';

  return result(format, '.000');
}

export function fCurrencyWithoutSymbol(number: InputValue) {
  const format = number ? numeral(number).format('0,0.000') : '';

  return result(format, '.000');
}

export function fPercent(number: InputValue) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number: InputValue) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number: InputValue) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format: string, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export function foatPercent(number: InputValue) {
  return numeral(Number(number) / 100).format('0.0%');
}

export function fRating(number: InputValue) {
  return numeral(number).format('0,0.0');
}

export function fPrice(price: number): number {
  return (price / 1) % 1 === 0 ? price : Number(price.toFixed(2));
}

export function fRateRomania(rate: number) {
  return parseFloat(Number(rate / 20).toFixed(2));
}

export function formatNumber(number: number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
